import { Link } from "@/lib/router";

export default function NotFoundPage() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 p-6 text-center">
      <p className="text-sm text-muted-foreground">404</p>
      <h1 className="text-xl font-semibold">페이지를 찾을 수 없어요</h1>
      <Link href="/" className="text-sm underline underline-offset-4">
        홈으로 돌아가기
      </Link>
    </div>
  );
}
